import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { importProvidersFrom, isDevMode } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { createInterceptorCondition, includeBearerTokenInterceptor, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, provideKeycloak } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { responseInterceptor } from './services/response-interceptor.service';
import { provideServiceWorker } from '@angular/service-worker';
import { authInterceptor } from './services/auth.interceptor.service';

const urlCondition = createInterceptorCondition({
	urlPattern: new RegExp(`^${environment.api}(/.*)?$`, 'i'),
	bearerPrefix: 'Bearer',
});

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(routes),
		importProvidersFrom(TranslateModule.forRoot()),
		provideHttpClient(withInterceptors([responseInterceptor, authInterceptor])),
		provideKeycloak({
			config: {
				url: environment.keycloak.url,
				realm: environment.keycloak.realm,
				clientId: environment.keycloak.clientId,
			},
			initOptions: {},
		}),
		{
			provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
			useValue: [urlCondition],
		},
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
};
